<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-5">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              clearable
              @clear="cleanFarm()"
              @change="showCalendar()"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm farm-form"
              size="large"
              v-model="pocketCatchsForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="`farm-${index}-${option}`"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3"
            v-if="isShowCalendar"
          >
            <label>{{ $t('common_words.calendar') }}</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-calendar shadow-sm date-form"
              size="large"
              v-model="pocketCatchsForm.calendar_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in calendars"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="`calendars-${index}-${option}`"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              :picker-options="pickerOptions"
              class="shadow-sm required-date date-form"
              v-model="pocketCatchsForm.date_sel"
              type="date"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
            <div class="row custom-mt-30">
              <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-2">
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="validate"
                  style="width: inherit"
                >
                  {{ $t('common_words.generate') }}
                </l-button>
              </div>
              <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 mb-2">
                <button
                  class="btn btn-info btn-fg"
                  @click.prevent="preload"
                  style="width: inherit"
                >
                  <i class="fa fa-table"></i> {{ $t('common_words.preload') }}
                </button>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-4"
                v-if="isAdminPocket()"
              >
                <el-button
                  wide
                  type="info"
                  icon="el-icon-s-tools"
                  class="btn-filter"
                  style="padding: 11px 20px; width: inherit"
                  @click="openAdminPocket()"
                >
                  {{ $t('common_words.manage_permissions') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <br />
      </card>
      <card class="custom-shadow-card-header" v-if="showPreload">
        <form>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <div class="form-group has-label">
                  <el-upload
                    drag
                    ref="upload"
                    :action="getAxiosURL() + '/auth/pockets/catchs/preload'"
                    :data="{
                      farm_id: pocketCatchsForm.farm_id,
                      date: formatDate,
                    }"
                    :headers="headerInfo"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :auto-upload="false"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      {{ $t('common_words.finished_format') }}
                      <em>{{ $t('common_words.click_to_load') }}</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                      {{ $t('common_words.xlsx_notice') }}
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center" v-if="isCreate()">
                <button
                  style="margin-right: 10px"
                  class="btn btn-info btn-fg"
                  @click.prevent="downloadFormat"
                >
                  <i class="fa fa-file-excel-o"></i>
                  {{ $t('common_words.download_file') }}
                </button>
                <button
                  class="btn btn-info btn-fg"
                  @click.prevent="submitUpload"
                >
                  <i class="fa fa-plus"></i> {{ $t('common_words.load_file') }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <br />
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('production.bagged_fruit_cluster')"
        v-if="pocketCatch"
      >
        <div class="mt-4 px-3">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <table
              aria-describedby="tabla-cosechados"
              class="table table-striped table-bordered"
            >
              <thead>
                <tr class="cusmtom-thead-color">
                  <th scope="col" class="text-center p-3 custom-header-label">
                    {{ $t('common_words.allotment') }}
                  </th>
                  <th scope="col" class="text-center p-3 custom-header-label">
                    {{ $t('common_words.area_roamed') }}
                  </th>
                  <th
                    v-if="showPremature()"
                    scope="col"
                    class="text-center p-3"
                    v-bind:style="
                      'background-color:' +
                      ribbons[1].color_code +
                      ';color:' +
                      ribbons[1].color_text
                    "
                  >
                    <strong>{{ $t('production.premature') }}</strong>
                  </th>
                  <th
                    v-if="showCurrent()"
                    scope="col"
                    class="text-center p-3"
                    v-bind:style="
                      'background-color:' +
                      ribbons[0].color_code +
                      ';color:' +
                      ribbons[0].color_text
                    "
                  >
                    <strong>{{ $t('production.currents') }}</strong>
                  </th>
                  <th
                    v-if="showChipped()"
                    scope="col"
                    class="text-center p-3"
                    v-bind:style="
                      'background-color:' +
                      ribbons[0].color_code +
                      ';color:' +
                      ribbons[0].color_text
                    "
                  >
                    <strong>{{ $t('production.banana_cutted') }}</strong>
                  </th>
                  <th scope="col" class="text-center p-3 custom-header-label">
                    {{ $t('production.bagged_total') }}
                  </th>
                  <th
                    v-if="!messageAlert"
                    scope="col"
                    class="text-center p-3 custom-header-label"
                  >
                    {{ $t('common_words.options') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(p, i) in pocketCatchsForm.nPocket" :key="i">
                  <td class="text-center">
                    <el-select
                      clearable
                      filterable
                      width="10"
                      class="select-primary custom-width-select required-lots shadow-sm"
                      size="large"
                      v-model="pocketCatchsForm.lots_sel[i]"
                      @change="setCoveredAreaByLot(i)"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="l in availableLots"
                        class="select-primary"
                        :value="l.id"
                        :label="l.name"
                        :key="l.id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td class="text-center">
                    <el-input
                      clearable
                      type="number"
                      min="0"
                      step="0.01"
                      style="width: 55%"
                      class="shadow-sm text-center"
                      @change="verifyData(i, pocketCatchsForm.covered_area)"
                      v-model="pocketCatchsForm.covered_area[i]"
                    >
                      <template slot="append">(ha)</template>
                    </el-input>
                  </td>
                  <td v-if="showPremature()" class="text-center">
                    <el-input
                      clearable
                      type="number"
                      min="0"
                      style="width: 110px"
                      class="shadow-sm text-center"
                      @change="verifyData(i, pocketCatchsForm.premature)"
                      v-model="pocketCatchsForm.premature[i]"
                    />
                  </td>
                  <td v-if="showCurrent()" class="text-center">
                    <el-input
                      clearable
                      type="number"
                      min="0"
                      style="width: 110px"
                      class="shadow-sm text-center"
                      @change="verifyData(i, pocketCatchsForm.current)"
                      v-model="pocketCatchsForm.current[i]"
                    />
                  </td>
                  <td v-if="showChipped()" class="text-center">
                    <el-input
                      clearable
                      type="number"
                      min="0"
                      style="width: 110px"
                      class="shadow-sm text-center"
                      @change="verifyData(i, pocketCatchsForm.chipped)"
                      v-model="pocketCatchsForm.chipped[i]"
                    />
                  </td>
                  <td class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalRow(i) }}</strong>
                    </h5>
                  </td>
                  <td
                    v-if="!messageAlert"
                    class="text-center"
                    style="display: table-cell"
                  >
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="pocketCatchsForm.nPocket++"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="pocketCatchsForm.nPocket > 1 && isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(i)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th scope="col" class="text-muted text-center">
                    {{ $t('common_words.total') }}
                  </th>
                  <td class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalColumn(4) }}</strong>
                    </h5>
                  </td>
                  <td v-if="showPremature()" class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalColumn(1) }}</strong>
                    </h5>
                  </td>
                  <td v-if="showCurrent()" class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalColumn(2) }}</strong>
                    </h5>
                  </td>
                  <td v-if="showChipped()" class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalColumn(3) }}</strong>
                    </h5>
                  </td>
                  <td class="text-center">
                    <h5 class="text-muted mt-3">
                      <strong>{{ calculateTotalColumn(0) }}</strong>
                    </h5>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                @click="validatePocket"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <el-dialog
        v-if="isAdminPocket()"
        width="85%"
        top="2%"
        :close-on-click-modal="false"
        :title="$t('production.bagged_capture_permits')"
        :visible.sync="adminPocket"
        @close="restoreSwitches"
      >
        <div class="row">
          <div class="col-12">
            <span style="font-size: 15px; word-break: break-word">
              1. {{ $t('production.bagged_info') }}
            </span>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <el-collapse v-model="activeName">
              <el-collapse-item
                class="custom-collapse-item"
                :title="`${$t(
                  'common_words.associate_permissions_general_level'
                )}...`"
                name="by-general"
              >
                <div class="row mx-2 mt-4 mb-4">
                  <div class="col-sm-12">
                    <el-table
                      stripe
                      :default-sort="{ prop: 'name', order: 'descending' }"
                      style="width: 100%"
                      :data="businessTableData"
                      :border="true"
                    >
                      <el-table-column
                        v-if="businessTableData.length > 1"
                        type="index"
                        width="65"
                      ></el-table-column>
                      <template v-if="businessTableData.length > 1">
                        <el-table-column
                          v-for="column in businessTableColumns"
                          :key="column.label"
                          :min-width="column.minWidth"
                          :prop="column.prop"
                          :label="column.label"
                        ></el-table-column>
                      </template>
                      <el-table-column
                        :label="$t('production.current_enable_disable')"
                      >
                        <template slot-scope="props">
                          <div class="align-center-cell-flex">
                            <l-switch
                              class="mt-2"
                              style="display: block"
                              on-text="ON"
                              off-text="OFF"
                              v-model="currentForm[props.row.id]"
                            >
                            </l-switch>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('production.premature_enable_disable')"
                      >
                        <template slot-scope="props">
                          <div class="align-center-cell-flex">
                            <l-switch
                              class="mt-2"
                              style="display: block"
                              on-text="ON"
                              off-text="OFF"
                              v-model="prematureForm[props.row.id]"
                            >
                            </l-switch>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('production.banana_cutted_enable_disable')"
                      >
                        <template slot-scope="props">
                          <div class="align-center-cell-flex">
                            <l-switch
                              class="mt-2"
                              style="display: block"
                              on-text="ON"
                              off-text="OFF"
                              v-model="chippedForm[props.row.id]"
                            >
                            </l-switch>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="$t('production.count_age_week_present')"
                      >
                        <template slot-scope="props">
                          <div class="align-center-cell-flex">
                            <l-switch
                              class="mt-2"
                              style="display: block"
                              on-text="ON"
                              off-text="OFF"
                              v-model="startForm[props.row.id]"
                            >
                            </l-switch>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="" fixed="right">
                        <template slot-scope="props">
                          <div class="text-center">
                            <l-button
                              wide
                              type="info"
                              class="btn-filter"
                              v-on:click="updateGeneralPermission(props.row.id)"
                            >
                              {{ $t('common_words.save') }}
                            </l-button>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item
                class="custom-collapse-item"
                :title="`${$t(
                  'common_words.associate_permissions_specific_users'
                )}...`"
                name="by-user"
              >
                <div class="row mx-2 mt-4">
                  <div
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                  >
                    <el-select
                      clearable
                      @clear="pagination.perPage = 5"
                      class="select-default mb-3 shadow-sm"
                      style="width: 200px"
                      v-model="pagination.perPage"
                      :placeholder="$t('common_words.per_page')"
                      filterable
                    >
                      <el-option
                        class="select-default"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                    <el-input
                      clearable
                      class="mb-3 shadow-sm"
                      style="width: 200px"
                      :placeholder="$t('common_words.search_records')"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    />
                  </div>
                  <div class="col-sm-12">
                    <el-table
                      stripe
                      :default-sort="{ prop: 'name', order: 'descending' }"
                      style="width: 100%"
                      :data="queriedData"
                      :border="true"
                    >
                      <el-table-column
                        type="index"
                        width="65"
                      ></el-table-column>
                      <el-table-column
                        v-for="column in tableColumns"
                        :key="column.label"
                        :min-width="column.minWidth"
                        :prop="column.prop"
                        :label="column.label"
                      ></el-table-column>
                      <el-table-column
                        min-width="110"
                        prop="props.users"
                        :label="$t('common_words.associated_users')"
                      >
                        <template slot-scope="scope">
                          <el-badge
                            class="custom-el-badge__content item"
                            v-if="scope.row.users.length > 0"
                            :hidden="scope.row.users.length == 1 ? true : false"
                            :value="200"
                            :max="scope.row.users.length - 1"
                          >
                            <el-button plain type="info" size="small">
                              {{ scope.row.users[0].first_name }}
                              {{ scope.row.users[0].last_name }} ({{
                                scope.row.users[0].username
                              }})
                            </el-button>
                          </el-badge>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :min-width="50"
                        :label="$t('common_words.operations')"
                        fixed="right"
                      >
                        <template slot-scope="props">
                          <div class="text-center">
                            <a
                              v-tooltip.top-center="$t('common_words.edit')"
                              class="btn-warning btn-simple btn-link custom-margin-actions"
                              @click="handleEdit(props.$index, props.row)"
                            >
                              <em
                                class="fa fa-edit custom-size-fa-actions"
                              ></em>
                            </a>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div
                    slot="footer"
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-2"
                  >
                    <div class="">
                      <p class="card-category" style="font-size: 14px">
                        {{ $t('table2.showing') }} {{ from + 1 }}
                        {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                        {{ total }} {{ $t('table2.entries') }}
                      </p>
                    </div>
                    <l-pagination
                      class="pagination-no-border"
                      ref="paginationCategory"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="pagination.total"
                      pageFirst="false"
                      pageLast="false"
                    >
                    </l-pagination>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <br />
      </el-dialog>
      <el-dialog
        :title="$t('common_words.associate_users_permissions')"
        :visible.sync="dialogUser"
      >
        <span>{{ $t('common_words.permissions_selected_users') }}:</span
        ><br /><br />
        <el-select
          @change="selectAllFromSelect('userForm.id', users)"
          multiple
          clearable
          class="select-primary custom-width-select shadow-sm required-users"
          v-model="userForm.id"
          filterable
          :placeholder="$t('common_words.select_one_or_many_users')"
        >
          <el-option
            v-for="option in users"
            class="select-primary selected-all"
            :value="option.id"
            :label="option.name"
            :key="option.id"
          >
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <button class="btn btn-danger" @click="dialogUser = false">
            {{ $t('common_words.cancel') }}</button
          >&nbsp;
          <button class="btn btn-success" @click="changeUsers()">
            {{ $t('common_words.confirm') }}
          </button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { mapActions } from 'vuex';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { Radio, RadioButton, RadioGroup } from 'element-ui';
import { Switch as LSwitch } from 'src/components';
import { Pagination as LPagination } from 'src/components/index';
import configTable2 from './table';
import configTable from './businessTable';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import { getSumOfValorFromArray } from 'src/util/Util.js';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';

export default {
  components: {
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup,
    LPagination,
    LSwitch,
  },

  computed: {
    ...configTable2().search,
    ...configTable().Search,

    availableLots() {
      return this.lots.filter(
        (lot) => !this.pocketCatchsForm.lots_sel.includes(lot.id)
      );
    },

    calendars() {
      if (this.pocketCatchsForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          if (element.id == this.pocketCatchsForm.farm_id) {
            calendars = element.calendars;
          }
        });

        return calendars;
      } else {
        return [];
      }
    },

    formatDate() {
      return moment(this.pocketCatchsForm.date_sel).format('Y-MM-DD');
    },
  },

  data() {
    return {
      prematureForm: [],
      currentForm: [],
      chippedForm: [],
      startForm: [],
      originalCurrentForm: {},
      originalPrematureForm: {},
      originalChippedForm: {},
      originalStartForm: {},
      permissionsForm: {
        premature: false,
        current: false,
        chipped: false,
        start: false,
      },
      userForm: {
        id: [],
        users_old: [],
        permission_id: [],
        module_id: 68,
      },
      pocketCatchsForm: {
        totalArea: 0,
        farm_id: null,
        date_sel: new Date(moment().format('YYYY-MM-DD').replace(/-/, '/')),
        nPocket: 1,
        lots_sel: [],
        covered_area: [],
        premature: [],
        current: [],
        chipped: [],
        calendar_sel: null,
        user_id: this.$store.state.auth.user.id,
      },
      adminPocket: false,
      dialogUser: false,
      farms: [],
      users: [],
      pocketCatch: false,
      lots: [],
      ribbons: [],
      isShowCalendar: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pagination: {},
      tableColumns: [],
      businessTableColumns: [],
      searchQuery: '',
      tableData: [],
      businessTableData: [],
      fuseSearch: null,
      activeName: 'by-general',
      messageAlert: null,
      showPreload: false,
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      fileList: [],
    };
  },

  mixins: [
    MixinPermissions,
    MixinNotification,
    mixinMasters,
    MixinMenu,
    MixinExport,
  ],
  watch: {
    '$i18n.locale': [
      'setupTable',
      'getSelectAll',
      'setupTable2',
      'forceRerender',
    ],
  },

  methods: {
    hideView() {
      this.pocketCatch = false;
      this.showPreload = false;
    },

    preload() {
      this.cleanForm();
      this.pocketCatchsForm.id = null;

      if (this.validateFilter()) {
        this.pocketCatch = false;
        this.showPreload = true;
      }
    },

    validateFilter() {
      this.pocketCatchsForm.id = null;

      if (this.pocketCatchsForm.farm_id == null) {
        this.highlightItem('farm-form');

        return false;
      } else if (this.pocketCatchsForm.date_sel == null) {
        this.highlightItem('date-form');

        return false;
      } else {
        return true;
      }
    },

    submitUpload() {
      this.$refs.upload.submit();
    },

    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')} `
      );
    },

    beforeUpload(file) {
      this.pocketCatchsForm.date_sel = moment(
        this.pocketCatchsForm.date_sel
      ).format('Y-MM-DD');
    },

    handleSuccess(res, file) {
      const errors = Array.isArray(res.errors) ? res.errors : [];
      const data = Array.isArray(res.data) ? res.data : [];
      const message = res.message || '';

      if (errors.length > 0) {
        let html = errors.map((e) => `<p>${e}</p>`).join('');
        if (message) html += `<hr/><p><strong>${message}</strong></p>`;

        SweetAlert.warning(html);
      } else if (data.length > 0) {
        let html = `<p><strong>${message}</strong></p>`;
        html += `<hr/><p>${i18n.t(
          'common_words.number_records_successfully'
        )}: ${data.length}</p>`;

        SweetAlert.success(html);
        this.cleanForm();
      } else {
        SweetAlert.info(i18n.t('common_words.no_new_data_was_recorded'));
      }

      this.pocketCatchsForm.date_sel = new Date(
        moment().format('YYYY-MM-DD').replace(/-/, '/')
      );

      this.$refs.upload.clearFiles();
    },

    downloadFormat() {
      let self = this;
      let data = self.pocketCatchsForm;
      data.route = 'pockets/catchs/preformat';
      data.name_file = 'precarga_embolse.xlsx';
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    getSelectAll() {
      this.users = this.concatAll(this.users.splice(1));
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    areAllCatchInactive() {
      const premature =
        !this.permissionsForm.premature && !this.enabledPremature();
      const current = !this.permissionsForm.current && !this.enabledCurrent();
      const chipped = !this.permissionsForm.chipped && !this.enabledChipped();

      return premature && current && chipped;
    },

    showPremature() {
      const first = this.permissionsForm.premature || this.enabledPremature();
      const second = this.areAllCatchInactive();
      return first || second;
    },

    showCurrent() {
      const first = this.permissionsForm.current || this.enabledCurrent();
      const second = this.areAllCatchInactive();
      return first || second;
    },

    showChipped() {
      const first = this.permissionsForm.chipped || this.enabledChipped();
      const second = this.areAllCatchInactive();
      return first || second;
    },

    /**
     * Me permite actualizar de manera general los permisos del
     * módulo para habilitar o deshabilitar los campos de captura
     */
    updateGeneralPermission(id) {
      this.showHideLoading(true);
      let data = {
        route: 'modules/othervalue',
        model_c: 'Permisos',
        module_id: this.userForm.module_id,
        business_id: id,
        key_json: ['current', 'premature', 'chipped', 'start'],
        value_key_json: {
          current: this.currentForm[id],
          premature: this.prematureForm[id],
          chipped: this.chippedForm[id],
          start: this.startForm[id] || false,
        },
      };

      Axios.postMasters(data).then((response) => {
        this.showHideLoading();
        this.showNotification(
          `${response.data.message}`,
          'success',
          'nc-settings-90',
          `${i18n.t('common_words.success_operation')}...`
        );
        this.updateBusinessTable(response.data.data.other_value);

        this.restoreSwitchesFromForm();
      });
    },

    /**
     * Método para abrir el CRUD del administrador de permisos del módulo
     * y cargar la información inicial al dialog de edición
     * @param index
     * @param row
     */
    handleEdit(index, row) {
      this.dialogUser = true;
      this.userForm.id = row.users.map((user) => user.id);
      this.userForm.users_old = this.userForm.id;
      this.userForm.permission_id = row.id;
    },

    /**
     * Método para ejecutar el cambio de usuarios de un permiso con el
     * servicio habilitado para la tarea
     */
    changeUsers() {
      this.showHideLoading(true);
      this.userForm.route = 'permissions/updatepermissionsuser';
      Axios.postMasters(this.userForm)
        .then((response) => {
          this.tableData = response.data.data;
          this.dialogUser = false;
          this.pocketCatch = false;
          this.cleanForm();
          this.showNotification(
            `${response.data.message}`,
            'success',
            'nc-settings-90',
            `${i18n.t('common_words.success_operation')}...`
          );
          this.forceRenderMenu();
          this.showHideLoading();
        })
        .catch((error) => {
          this.dialogUser = false;
          this.showMessageErrors(error);
        });
    },

    /**
     * Setear la data de apertura y cierre del formulario de
     * administrador de permisos del módulo en verdadera y abrir el modal
     */
    openAdminPocket() {
      this.adminPocket = true;
      this.originalCurrentForm = JSON.parse(JSON.stringify(this.currentForm));
      this.originalPrematureForm = JSON.parse(
        JSON.stringify(this.prematureForm)
      );
      this.originalChippedForm = JSON.parse(JSON.stringify(this.chippedForm));
      this.originalStartForm = JSON.parse(JSON.stringify(this.startForm));
    },

    /**
     * Método para restaurar los switches de captura de la
     * información del módulo a su estado original
     */
    restoreSwitches() {
      this.currentForm = JSON.parse(JSON.stringify(this.originalCurrentForm));
      this.prematureForm = JSON.parse(
        JSON.stringify(this.originalPrematureForm)
      );
      this.chippedForm = JSON.parse(JSON.stringify(this.originalChippedForm));
      this.startForm = JSON.parse(JSON.stringify(this.originalStartForm));
    },

    restoreSwitchesFromForm() {
      this.originalCurrentForm = JSON.parse(JSON.stringify(this.currentForm));
      this.originalPrematureForm = JSON.parse(
        JSON.stringify(this.prematureForm)
      );
      this.originalChippedForm = JSON.parse(JSON.stringify(this.chippedForm));
      this.originalStartForm = JSON.parse(JSON.stringify(this.startForm));
    },

    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.pocketCatchsForm.calendar_sel = null;
      this.pocketCatch = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.pocketCatchsForm.farm_id
      );
      if (element) {
        this.pocketCatchsForm.totalArea = this.getTotalAreaFromFarm(
          this.farms,
          this.pocketCatchsForm.farm_id
        );
        this.isShowCalendar = element.calendars.length > 1;
        this.pocketCatchsForm.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }

      this.isShowCalendar = false;
    },

    /**
     * Ejecuta las validaciones del formulario de reporte y confirma que
     * las reglas se cumplan para cargar la información solicitada
     */
    validate() {
      if (this.pocketCatchsForm.farm_id == null)
        return this.validationInputsRequired('farm');
      else if (this.pocketCatchsForm.date_sel == null)
        return this.validationInputsRequired('date');
      else if (this.pocketCatchsForm.calendar_sel == null)
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      else {
        this.messageAlert = null;
        this.cleanForm();
        this.loadPocket();
        this.pocketCatchsForm.totalArea = this.getTotalAreaFromFarm(
          this.farms,
          this.pocketCatchsForm.farm_id
        );
      }
    },

    /**
     * Ejecuta las reglas y validaciones de la información registrada en la
     * tabla de embolse, esperando que se cumplan para ejecutar la acción
     * de guardado o edición de los datos
     */
    validatePocket() {
      if (
        this.pocketCatchsForm.lots_sel.length == 0 ||
        (this.pocketCatchsForm.nPocket > 0 &&
          this.pocketCatchsForm.lots_sel.length < this.pocketCatchsForm.nPocket)
      ) {
        return this.validationInputsRequired('lots');
      } else {
        if (this.pocketCatchsForm.covered_area.length == 0) {
          SweetAlert.warning(i18n.t('sweet_alert.production.roamed_area_info'));
        } else {
          if (
            getSumOfValorFromArray(this.pocketCatchsForm.covered_area) >
            this.pocketCatchsForm.totalArea
          ) {
            SweetAlert.warning(
              `${i18n.t('sweet_alert.production.wrong_area')}"${Number(
                this.pocketCatchsForm.totalArea
              ).toFixed(2)}(ha)", ${i18n.t(
                'sweet_alert.production.cannot_save'
              )}`
            );
          } else {
            if (
              (this.permissionsForm.premature &&
                this.pocketCatchsForm.premature.length == 0 &&
                this.permissionsForm.current &&
                this.pocketCatchsForm.current.length == 0 &&
                this.permissionsForm.chipped &&
                this.pocketCatchsForm.chipped.length == 0) ||
              (this.enabledPremature() &&
                this.pocketCatchsForm.premature.length == 0 &&
                this.enabledCurrent() &&
                this.pocketCatchsForm.current.length == 0 &&
                this.enabledChipped() &&
                this.pocketCatchsForm.chipped.length == 0) ||
              (this.areAllCatchInactive() &&
                this.pocketCatchsForm.premature.length == 0 &&
                this.pocketCatchsForm.current.length == 0 &&
                this.pocketCatchsForm.chipped.length == 0)
            ) {
              SweetAlert.warning(
                i18n.t('sweet_alert.production.missing_bagging_row_info')
              );
            } else {
              this.validateLinesTotalArea()
                .then(() => {
                  this.validateLinesPocket()
                    .then(() => {
                      this.storeUpdatePocketCatchs();
                    })
                    .catch((error) => {
                      SweetAlert.warning(
                        i18n.t('sweet_alert.production.missing_bagging_info') +
                          (error + 1)
                      );
                    });
                })
                .catch((error) =>
                  SweetAlert.warning(
                    `${i18n.t('sweet_alert.production.digited_area')}°${
                      error[0] + 1
                    }, ${i18n.t(
                      'sweet_alert.production.cannot_be_greater_than'
                    )}"${error[1]}(ha)", ${i18n.t(
                      'sweet_alert.production.check_info'
                    )}`
                  )
                );
            }
          }
        }
      }
    },

    /**
     * Válida línea por línea cada fila de la tabla de embolse
     * verificando que los datos están registrados correctamente
     */
    async validateLinesPocket() {
      return new Promise((resolve, reject) => {
        for (let index = 0; index < this.pocketCatchsForm.nPocket; index++) {
          if (
            !this.pocketCatchsForm.covered_area[index] ||
            isNaN(parseInt(this.pocketCatchsForm.covered_area[index]))
          )
            reject(index);

          if (
            parseInt(this.pocketCatchsForm.premature[index]) !== 0 &&
            (!this.pocketCatchsForm.premature[index] ||
              isNaN(parseInt(this.pocketCatchsForm.premature[index]))) &&
            parseInt(this.pocketCatchsForm.current[index]) !== 0 &&
            (!this.pocketCatchsForm.current[index] ||
              isNaN(parseInt(this.pocketCatchsForm.current[index]))) &&
            parseInt(this.pocketCatchsForm.chipped[index]) !== 0 &&
            (!this.pocketCatchsForm.chipped[index] ||
              isNaN(parseInt(this.pocketCatchsForm.chipped[index])))
          ) {
            reject(index);
          }
        }

        resolve();
      });
    },

    /**
     * Validar cada línea que el área digitada
     * por lote no pase el área permitida
     */
    async validateLinesTotalArea() {
      return new Promise((resolve, reject) => {
        for (let i = 0; i < this.pocketCatchsForm.nPocket; i++) {
          const lotArea = this.getAreaFromLot(
            this.farms,
            this.pocketCatchsForm.farm_id,
            this.pocketCatchsForm.lots_sel[i]
          );
          if (Number(this.pocketCatchsForm.covered_area[i]) > Number(lotArea))
            reject([i, Number(lotArea).toFixed(2)]);
        }
        resolve();
      });
    },

    confirmDelete() {
      if (this.pocketCatchsForm.id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.production.selected_bagging_capture')
        ).then((result) => {
          if (result.value) this.deletePocket();
        });
      } else this.cleanForm();
    },

    deletePocket() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.pocketCatchsForm.route = 'pockets/catchs';
        Axios.destroyMaster(this.pocketCatchsForm)
          .then(() => {
            this.pocketCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t('show_notification.production.bagged_deleted'),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },

    /**
     * Guardar o actualizar la información de embolse registrada en la tabla
     */
    storeUpdatePocketCatchs() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.pocketCatchsForm.route = 'pockets/catchs';
        this.pocketCatchsForm.pocket_date = this.pocketCatchsForm.date_sel;
        this.pocketCatchsForm.ribbons_id = [
          this.ribbons[0].id,
          this.ribbons[1].id,
        ];

        if (this.pocketCatchsForm.id) {
          Axios.updateMaster(this.pocketCatchsForm)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.pocketCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.pocketCatchsForm)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.pocketCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    /**
     * Limpia la información referente a la finca
     */
    cleanFarm() {
      this.messageAlert = null;
      this.pocketCatchsForm.farm_id = null;
      this.pocketCatchsForm.totalArea = 0;
    },

    /**
     * Limpia el formulario de la tabla de embolse a su estado inicial
     */
    cleanForm() {
      this.pocketCatchsForm.nPocket =
        this.showPremature() || this.showCurrent() || this.showChipped()
          ? 1
          : 0;
      if (!this.pocketCatchsForm.farm_id) {
        this.pocketCatchsForm.totalArea = 0;
      }

      this.pocketCatchsForm.lots_sel = [];
      this.pocketCatchsForm.covered_area = [];
      this.pocketCatchsForm.premature = [];
      this.pocketCatchsForm.current = [];
      this.pocketCatchsForm.chipped = [];
      delete this.pocketCatchsForm.id;
    },

    /**
     * Método para eliminar línea de la tabla de embolse
     */
    handleDelete(index) {
      try {
        this.pocketCatchsForm.covered_area.splice(index, 1);
      } catch (error) {}

      try {
        this.pocketCatchsForm.premature.splice(index, 1);
      } catch (error) {}

      try {
        this.pocketCatchsForm.current.splice(index, 1);
      } catch (error) {}

      try {
        this.pocketCatchsForm.chipped.splice(index, 1);
      } catch (error) {}

      try {
        this.pocketCatchsForm.lots_sel.splice(index, 1);
        let tmp = Object.assign([], this.pocketCatchsForm.lots_sel);
        this.pocketCatchsForm.lots_sel = [];
        setTimeout(() => {
          this.pocketCatchsForm.lots_sel = Object.assign([], tmp);
        }, 5);
      } catch (error) {}

      this.pocketCatchsForm.nPocket--;
    },

    /**
     * Método encargado de buscar la información al backend y cargar la
     * información si ya existe en la tabla de embolse
     */
    loadPocket() {
      this.showHideLoading(true);
      this.pocketCatchsForm.date_sel = this.pocketCatchsForm.date_sel;
      let data = {
        route: 'pockets/catchs/indexspecified',
        farm_id: this.pocketCatchsForm.farm_id,
        pocket_date: moment(this.pocketCatchsForm.date_sel).format('Y-MM-DD'),
      };

      Promise.all([
        Axios.getMasters('farms/farms/lots/' + this.pocketCatchsForm.farm_id),
        Axios.getMasters(
          'ribbons/' +
            moment(this.pocketCatchsForm.date_sel).format('Y-MM-DD') +
            '/' +
            this.pocketCatchsForm.calendar_sel
        ),
        Axios.postMasters(data),
      ])
        .then((response) => {
          const [response_lots, response_ribbons, response_data] = response;
          this.lots = response_lots.data.data;
          this.ribbons = response_ribbons.data;

          if (this.ribbons) this.pocketCatch = true;

          if (response_data.data.data['closing']) {
            this.messageAlert = response_data.data.data['closing'].message;
          } else this.messageAlert = null;

          if (response_data.data.data[0]) {
            let editForm = response_data.data.data[0];
            this.pocketCatchsForm.id_lots = editForm.id_lots;
            this.pocketCatchsForm.id = editForm.id;
            this.pocketCatchsForm.nPocket = editForm.nPocket;
            this.pocketCatchsForm.covered_area = editForm.covered_area;
            this.pocketCatchsForm.premature = editForm.premature;
            this.pocketCatchsForm.current = editForm.current;
            this.pocketCatchsForm.chipped = editForm.chipped;
            this.pocketCatchsForm.calendar_sel = editForm.calendar_id;
            this.pocketCatchsForm.user_id = this.$store.state.auth.user.id;

            if (editForm.ribbons[0]) {
              this.$set(this.ribbons, 0, editForm.ribbons[0]);
            }

            if (editForm.ribbons[1]) {
              this.$set(this.ribbons, 1, editForm.ribbons[1]);
            }

            try {
              this.pocketCatchsForm.lots_sel = [];
              setTimeout(() => {
                this.pocketCatchsForm.lots_sel = Object.assign(
                  [],
                  editForm.id_lots
                );
              }, 5);
            } catch (error) {}
          } else {
            this.cleanForm();
          }

          this.showPreload = false;
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.cleanForm();
          this.showHideLoading();
          this.pocketCatch = false;
          if (error.response.data.message)
            SweetAlert.warning(error.response.data.message);
        });
    },

    /**
     * Verifica que el dato registrado sea
     * tipo entero definido y lo setea en la data
     * mencionada sobre el parametro type
     * @param index
     * @param type
     */
    verifyData(index, type) {
      if (isNaN(parseInt(type[index]))) {
        try {
          this.$set(type, index, null);
        } catch (error) {}
      }
    },

    setCoveredAreaByLot(index) {
      const lot = this.lots.find(
        (item) => item.id === this.pocketCatchsForm.lots_sel[index]
      );

      this.$set(
        this.pocketCatchsForm.covered_area,
        index,
        lot ? Number(lot.area) : null
      );
    },

    calculateTotalRow(index) {
      let total =
        (this.showPremature()
          ? parseInt(
              this.pocketCatchsForm.premature[index]
                ? this.pocketCatchsForm.premature[index]
                : 0
            )
          : 0) +
        (this.showCurrent()
          ? parseInt(
              this.pocketCatchsForm.current[index]
                ? this.pocketCatchsForm.current[index]
                : 0
            )
          : 0);

      return total;
    },

    calculateTotalColumn(type) {
      let total = 0;
      let arraySum = [];
      switch (type) {
        case 1:
          arraySum = this.showPremature()
            ? this.pocketCatchsForm.premature
            : [];
          break;
        case 2:
          arraySum = this.showCurrent() ? this.pocketCatchsForm.current : [];
          break;
        case 3:
          arraySum = this.showChipped() ? this.pocketCatchsForm.chipped : [];
          break;
        case 4:
          arraySum = this.pocketCatchsForm.covered_area;
          break;
        default:
          if (this.showPremature()) {
            this.pocketCatchsForm.premature.forEach((element) => {
              total += parseInt(element ? element : 0);
            });
          }

          if (this.showCurrent()) {
            this.pocketCatchsForm.current.forEach((element) => {
              total += parseInt(element ? element : 0);
            });
          }

          return total;
      }

      if (arraySum) {
        arraySum.forEach((element) => {
          const value = element ? element : 0;
          total += type === 4 ? parseFloat(value) : parseInt(value);
        });
      }

      return type === 4 ? total.toFixed(2) : total;
    },

    updateBusinessTable(others) {
      const otherValues = JSON.parse(others);
      this.businessTableData = this.$store.state.auth.user.business.filter(
        (item) => {
          if (item.id != 1) {
            this.currentForm[item.id] = otherValues[item.id]
              ? otherValues[item.id].current
              : false;
            this.chippedForm[item.id] = otherValues[item.id]
              ? otherValues[item.id].chipped
              : false;
            this.prematureForm[item.id] = otherValues[item.id]
              ? otherValues[item.id].premature
              : false;
            this.startForm[item.id] =
              (otherValues[item.id] && otherValues[item.id].start) || false;

            return item;
          }
        }
      );

      if (Object.keys(otherValues).length === 1) {
        Object.keys(otherValues).forEach((id) => {
          this.permissionsForm.premature = otherValues[id]
            ? otherValues[id].premature
            : false;
          this.permissionsForm.current = otherValues[id]
            ? otherValues[id].current
            : false;
          this.permissionsForm.chipped = otherValues[id]
            ? otherValues[id].chipped
            : false;
          this.permissionsForm.start =
            (otherValues[id] && otherValues[id].start) || false;
        });
      } else if (Object.keys(otherValues).length > 1) {
        this.permissionsForm.premature = false;
        this.permissionsForm.current = false;
        this.permissionsForm.chipped = false;
        this.permissionsForm.start = false;
      }
    },
    setupTable() {
      const { Table } = configTable();
      this.businessTableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
    setupTable2() {
      const { Table } = configTable2();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.setupTable2();
      this.showHideLoading(true);

      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('permissions/module/68'),
        Axios.getMasters('users/indexfield'),
        Axios.getMasters('modules/othervalue/68'),
      ])
        .then((response) => {
          const [
            responseFarm,
            responsePermission,
            responseUsers,
            responseModule,
          ] = response;

          this.users = this.concatAll(responseUsers.data.data);
          this.farms = responseFarm.data.data;

          this.tableData = responsePermission.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });

          this.updateBusinessTable(responseModule.data.data.other_value);
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('pockets');
  },

  destroyed() {
    this.deselectedItemOnMenu('pockets');
  },
};
</script>
<style>
.display-btn-admin {
  display: flex;
  align-content: center;
  flex-direction: row;
  align-items: center;
}
</style>
